import type { StripeMode } from './useStripeMode';

const COPY: Record<StripeMode, { title: string; body: string; tone: string }> = {
    test: {
        title: 'Stripe en modo pruebas',
        body: 'Este entorno usa una clave de pruebas. Un reembolso no devuelve dinero real. La clave no se muestra.',
        tone: 'border-amber-500/40 bg-amber-500/10 text-amber-100',
    },
    live: {
        title: 'Stripe en modo live',
        body: 'Este entorno usa la clave live. Un reembolso devuelve dinero real. La clave no se muestra.',
        tone: 'border-rose-500/40 bg-rose-500/10 text-rose-100',
    },
    missing: {
        title: 'Sin clave de Stripe',
        body: 'Este entorno no tiene clave de Stripe. Sync y reembolsos no pueden ejecutarse.',
        tone: 'border-border bg-muted/40 text-foreground',
    },
    unknown: {
        title: 'Modo de Stripe sin confirmar',
        body: 'No se ha podido saber si la clave es de pruebas o live. No reembolses hasta comprobarlo. La clave no se muestra.',
        tone: 'border-amber-500/40 bg-amber-500/10 text-amber-100',
    },
};

export function StripeModeNotice({ mode, pending }: { mode: StripeMode | undefined; pending?: boolean }) {
    if (pending || !mode) {
        return (
            <p className="rounded-xl border border-border bg-card px-4 py-3 text-sm text-muted-foreground">
                Comprobando si Stripe está en modo pruebas o live…
            </p>
        );
    }
    const copy = COPY[mode];
    return (
        <div className={`rounded-xl border px-4 py-3 ${copy.tone}`} data-stripe-mode={mode}>
            <p className="text-sm font-semibold">{copy.title}</p>
            <p className="mt-1 text-sm">{copy.body}</p>
        </div>
    );
}
